import type { FC } from "react";
import { Badge } from "../../badge";
import type { GameThumbData } from "../../GameThumb";
import GameRtpBadge from "./GameRtpBadge";

type Props = {
  game: GameThumbData;
  rtp?: number;
};

const GameHorizontalPreviewBadges: FC<Props> = ({ game, rtp }) => {
  const provider = game.menuItem?.[0];
  const visibleRtp = getVisibleRtp(rtp);

  return (
    <div className="gap-2 hidden md:flex">
      {provider?.name && <Badge variant="secondary">{provider.name}</Badge>}
      {visibleRtp !== null && <GameRtpBadge rtp={visibleRtp} />}
    </div>
  );
};

// Trims float noise (96.45000000001) to two decimals; null when there is nothing worth showing.
function getVisibleRtp(rtp?: number) {
  if (rtp === undefined || !Number.isFinite(rtp) || rtp <= 0) return null;
  return Number(rtp.toFixed(2));
}

export default GameHorizontalPreviewBadges;
